<template>
  <section>
    <div class="title" v-if="perfil && perfil.company_data">
      <small>Gerenciando o negócio:</small>
      <p>{{ perfil.company_data.name }}</p>
    </div>
    <div class="panel">
      <div v-for="box in panel" :key="box.topic">
        <router-link class="box" :to="box.url" v-if="box.role" :class="data == box.topic ? 'active' : ''" active-class="">
          <div>
            <i v-if="box.icon" :class="`pi pi-${box.icon}`"></i>
            {{ box.topic }}
          </div>
          <i class="pi pi-arrow-right" v-if="data == box.topic"></i>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["data"],
  filters: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {
    ...mapState({
      perfil: state => state.user.dadosCompletos,
    }),
    managerIntegration() {
      return this.$store.state.user.gerenciarIntegracao;
    },
    managerUser() {
      return this.$store.state.user.gerenciarUsuario;
    },
    panel() {
      let items = [
        {
          topic: "Minha conta",
          icon: "user",
          url: "/settings",
          role: true,
        },
        {
          topic: "Integrações",
          icon: "cog",
          url: "/settings/integrations",
          role: this.managerIntegration == 1,
        },
        {
          topic: "Plano",
          icon: "dollar",
          url: "/settings/plan",
          role: this.managerIntegration == 1,
        },
        {
          topic: "Usuários",
          icon: "users",
          url: "/settings/users",
          role: this.managerUser == 1,
        },
        {
          topic: "Contas vinculadas",
          icon: "user-plus",
          url: "/settings/accounts-merged",
          role: this.managerIntegration == 1,
        },
        {
          topic: "Importações",
          icon: "arrow-circle-up",
          url: "/settings/imports",
          role: this.managerIntegration == 1,
        },
      ];
      return items;
    },
  },
};
</script>

<style lang="scss" scoped>
.router-link-active {
  background: red;
  background-color: #747474;
  color: #e6e6e6;
}
.title {
  margin-bottom: 30px;
  small {
    font-size: 14px;
    text-align: left;
    color: #7a7a7a;
    margin-bottom: 5px;
    display: inline-block;
  }
  p {
    font-size: 18px;
    font-weight: 500;
    text-align: left;
    color: $dark;
  }
}
.panel {
  display: inline-block;
  align-items: center;
  margin-right: 45px;
  min-width: 325px;
  max-width: 325px;
  height: auto;
  // box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  div {
    &:last-child {
      .box {
        border-bottom: 0;
      }
    }
  }

  .box {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    background-color: rgba(255,255,255,.5);
    color: $cinza-escuro;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: .6rem;
    font-weight: normal;
    padding: 15px 20px;
    text-decoration: none;
    transition: all 100ms;
    width: 100%;

    &:hover:not(.active) {
      background: rgba(238, 238, 238, 0.243);
    }

    &.active {
      color: #fd3064;
      font-weight: 500;
    }

    > div {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: .6rem;
    }

    i {
      opacity: .6;
    }
  }
}

@media only screen and (max-width: 997px) {
  .panel {
    display: none;
  }
}
</style>
